module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><path fill=\"#c60b1e\" d=\"M0 0h640v480H0z\"/><path fill=\"#ffc400\" d=\"M0 120h640v240H0z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/es.svg
// module id = 49
// module chunks = 0